// extracted by mini-css-extract-plugin
export default {"errorMessage":"ErrorMessage_errorMessage__N7rvx","errorDimmer":"ErrorMessage_errorDimmer__RsczK"};